import React from "react";
/**
 * This is mostly if you need do something like use refs with
 * unknown children that may not support refs
 */
export default class SimpleObjectComponent extends React.Component {
  render() {
    return this.props.children;
  }
}
